import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';

export default function AdminLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="page-full" style={{ background: '#000' }}>
      <Outlet />
    </div>
  );
}
